import { Mail } from "lucide-react";

export const MockFrame = ({ label, children, testid }) => (
  <div data-testid={testid} className="relative rounded-2xl border border-slate-200 bg-white shadow-[0_18px_40px_-24px_rgba(18,35,74,0.35)] overflow-hidden">
    <div className="flex items-center gap-1.5 px-3 py-2 bg-slate-50 border-b border-slate-100">
      <span className="h-2.5 w-2.5 rounded-full bg-[#F5551E]/70" /><span className="h-2.5 w-2.5 rounded-full bg-amber-300" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-300" />
      {label && <span className="ml-2 text-[10px] font-bold uppercase tracking-widest text-slate-400">{label}</span>}
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export const EmailFrame = ({ m, subject, testid, children }) => (
  <MockFrame testid={testid} label="Email">
    <div className="text-[11px] text-slate-500 space-y-0.5 pb-3 border-b border-slate-100">
      <p className="flex items-center gap-1.5"><Mail size={12} className="text-[#F5551E]" /> <strong className="text-slate-700">{m.e_from}</strong></p>
      <p><span className="text-slate-400">{m.subject}:</span> <span className="font-semibold text-[#12234A]">{subject}</span></p>
    </div>
    <div className="pt-3">
      <img src={`${process.env.PUBLIC_URL}/logo-footer.png`} alt="" className="h-6 w-auto mb-3 rounded bg-[#12234A] px-2 py-0.5" />
      {children}
    </div>
  </MockFrame>
);

export const EmailButton = ({ children }) => (
  <div className="text-center my-3"><span className="inline-block bg-[#F5551E] text-white text-xs font-bold rounded-xl px-4 py-2">{children}</span></div>
);
